import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Modal } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiFillEye } from "react-icons/ai";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ConsultaAsociado from "./ConsultaAsociado";
// eslint-disable-next-line react/prop-types
function ConsultaActual({ id, descripcion }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Estilos del modal
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "900px",
    height: "70vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflowY: "auto",
  };

  // Definir columnas según la estructura de la API
  const [columns] = useState([
    { Header: "ID", accessor: "id" },
    { Header: "Caso Principal", accessor: "idPrincipal" },
    { Header: "Caso Asociado", accessor: "idAsociado" },
    {
      Header: "Caso Asociado",
      accessor: "casoAsociado",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        // eslint-disable-next-line react/prop-types
        <ConsultaAsociado id={row.original.idAsociado} />
      ),
    },
  ]);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/ObtenerCasosAsociados/${id}/Actual`
        );

        const data = response.data.map((item) => ({
          id: item.id,
          idPrincipal: item.idPrincipal,
          idAsociado: item.idAsociado,
        }));

        setRows(data);
      } catch (error) {
        console.error("Error al obtener anexos:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-crear-caso">Consultar caso asociado</Tooltip>}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={handleOpen}
          // eslint-disable-next-line react/prop-types
          disabled={rows.length === 0 || rows.every((row) => row.idAsociado === 0)}
        >
          <ChecklistIcon style={{ color: "white", fontSize: "1.2rem" }} />
        </Button>
      </OverlayTrigger>

      {/* Modal con la tabla */}
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
        <Box sx={modalStyle}>
          {descripcion}
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
              onClick={handleClose}
              variant="contained"
              color="light"
              style={{ marginLeft: 10, border: "2px solid blue", color: "blue" }}
            >
              <span style={{ color: "blue" }}> Cerrar</span>
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ConsultaActual;
